module.exports = __webpack_public_path__ + "img/USDAOrganicLogoBlack.9c4e1e0b.svg";